import type { SectionsContent } from "./MarketingContent";

// Annotated so that a section whose items carry no subheader does not narrow
// the type for the sections that do.
export const marketingContentData: SectionsContent = {
  team: [
    { title: "Caroline Woolard", description: "Executive Director" },
    { title: "Malkie Rothman", description: "Chief Operating Officer" },
    { title: "Martin Pettis", description: "Chief of Staff" },
    { title: "Isaiah Madison", description: "Director of Community and Outreach" },
    { title: "Naja Gordon", description: "Community Support" },
    { title: "Futaba", description: "Community Support" },
    { title: "Willa Köerner", description: "Copywriting" },
    { title: "Minima.nyc", description: "Engineering" },
  ],
  advisors: [
    {
      title: "Oihane Amurrio",
      description: "Lead Program Developer, Mondragon Team Academy",
    },
    {
      title: "Sarah Calderon",
      description: "Founding Executive Director, Creatives Rebuild New York",
    },
    { title: "Pablo Helguera", description: "Artist + Educator" },
    { title: "Sophie Landres", description: "Curator" },
    { title: "Ruby Lerner", description: "Founding Director, Creative Capital" },
    { title: "Sofía Olascoaga", description: "Curator + Educator" },
    {
      title: "Martin Pettis",
      description: "Executive Director, WE CARE Therapies",
    },
    { title: "Nathan Schneider", description: "University of Colorado" },
    { title: "Jean Shin", description: "Artist + Educator" },
    { title: "Gesyada Annisa Namora Siregar", description: "Curator" },
    {
      title: "Claire Wathen",
      description: "Web of Us, Visiting Fellow at Oxford University",
    },
    {
      title: "Wendy Woon",
      description:
        "Artist, former Edward John Noble Deputy Director for Education, MoMA",
    },
  ],
};

export default marketingContentData;
